import { authState } from "../modules/auth/state";
import { normalizeState } from "../modules/normalized/state";

export const storeModel = {
    auth: authState,
    normalize: normalizeState,
};

export type RootState = typeof storeModel;
